module.exports = __webpack_public_path__ + "img/continue-button.146945bb.png";